import { motion } from "framer-motion";
import { mediaUrl } from "@/lib/api";
import { ItemTools } from "./ItemTools";

export const PhotoMasonry = ({ photos, editing, reload, onOpen }) => (
  <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [column-fill:_balance]" data-testid="photo-masonry">
    {photos.map((p, i) => (
      <motion.figure key={p.id} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="group relative mb-4 cursor-zoom-in break-inside-avoid overflow-hidden bg-[#ECEAE6]" onClick={() => onOpen(i)} data-testid={`photo-${i}`}>
        <img src={mediaUrl(p.media_id)} alt={p.title || ""} loading="lazy" className="block h-auto w-full transition-transform [transition-duration:1.2s] ease-out group-hover:scale-[1.06]" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-5 text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 translate-y-3">
          <span className="font-display text-xl font-extrabold tracking-tight">{p.title}</span>
          <span className="font-mono-label text-xs text-white/80">{String(i + 1).padStart(2, "0")}</span>
        </figcaption>
        {editing && <ItemTools item={p} i={i} list={photos} kind="image" reload={reload} />}
      </motion.figure>
    ))}
  </div>
);
